import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';

import BaseRouteHandler from '../../common/routeHandlers/BaseRouteHandler';

export const initialize = () => {
  const SearchResultPageCodeSplit = lazyForPaint(() =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "chunk-search-result-page" */ '@atlassian/mpac-search/search-result-page'
    ).then((module) => module.default)
  );

  const RouteHandler = () => {
    return (
      <BaseRouteHandler scrollToTopOnPathChange>
        <SearchResultPageCodeSplit />
      </BaseRouteHandler>
    );
  };

  return RouteHandler;
};

export default initialize();
